module.exports = __webpack_public_path__ + "media/s disease.71a4b477.wav";